<div class="container shared-container mx-auto confirmation-container">
    <div class="row justify-content-center invisible">
        <div class="col-12 col-md-5 card-size">
            <vg-button
                class="btn-back d-none d-sm-block"
                [icon]="'back-arrow'"
                [href]="'/purchase/custom' | formatUrl | async"
                [style]="'link'"
            >
                {{ 'vg_landing_all_bton-return-label' | translate }}
            </vg-button>
            <vg-button
                class="btn-back d-sm-none d-md-none d-lg-none d-xl-none"
                [icon]="'back-arrow'"
                [href]="'/purchase/custom' | formatUrl | async"
                [onlyIcon]="true"
                [style]="'link'"
            ></vg-button>
        </div>
        <div class="col-12 col-md-7"></div>
    </div>
    <div class="row justify-content-center">
        <div class="col-12 col-md-5 card-size">
            <h3
                class="purchase-confirmation-title d-flex align-items-center justify-content-center justify-content-md-start"
            >
                <img [src]="'vg/images/check-arrow.svg' | cdn" alt="" />
                <span>
                    {{
                        'vg_landing_purchase_confirmation_h3-title' | translate
                    }}
                </span>
            </h3>
            <vg-card-giftcard-ready
                [card]="card$ | async"
            ></vg-card-giftcard-ready>
        </div>
        <div class="col-12 col-md-7 card-size-2 info-payment card-size-outside">
            <vg-purchase-confirmation
                [card]="card$ | async"
            ></vg-purchase-confirmation>
        </div>
    </div>
</div>
